import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//@ts-expect-error no types
import PreviewViewportSizeHOC from 'ContentEditorUI/js/containers/PreviewViewportSizeHOC';
import { undoModuleReducerChange, redoModuleReducerChange
//@ts-expect-error no types
} from 'ContentEditorUI/redux/actions/undoRedoActions';
//@ts-expect-error no types
import AppWideKeyboardShortcutsContainer from 'ContentEditorUI/containers/AppWideKeyboardShortcutsContainer';
//@ts-expect-error no types
import PreloadedIframeProxy from 'ContentEditorUI/components/temp/PreloadedIframeProxytoExtract';
//@ts-expect-error no types
import { clearSelectedItem } from 'ContentEditorUI/redux/actions/selectionActions';
import { getSelectedItemId } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { getIsInDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
//@ts-expect-error no types
import SkeletonPreviewIframeStyler from 'ContentEditorUI/containers/SkeletonPreviewIframeStyler';
import PreviewIframeStylesManager from 'ContentEditorUI/utils/PreviewIframeStylesManager';
import { getPreviewIframeWrapperElement } from 'ContentEditorUI/lib/layoutDom';
import { CONTENT_PANE_CLASSNAME, EDIT_PANE_CLASSNAME } from 'ContentEditorUI/constants/dom';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContentViewContainer = () => {
  const dispatch = useDispatch();
  const selectedItemId = useSelector(getSelectedItemId);
  const isInDefaultBreakpointMode = useSelector(getIsInDefaultBreakpointMode);

  // TODO make any parent app click (outside edit sidebar?) clear selection?
  const handleClickOutsideIframe = useCallback(() => {
    if (!isInDefaultBreakpointMode && selectedItemId) {
      dispatch(clearSelectedItem());
    }
  }, [dispatch, isInDefaultBreakpointMode, selectedItemId]);
  const previewIframeElement = useMemo(() => getPreviewIframeWrapperElement(), []);
  useEffect(() => {
    if (previewIframeElement) {
      previewIframeElement.addEventListener('click', handleClickOutsideIframe);
    }
    return () => {
      if (previewIframeElement) {
        previewIframeElement.removeEventListener('click', handleClickOutsideIframe);
      }
    };
  }, [handleClickOutsideIframe, previewIframeElement]);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized (Classes required by ContentEditorUI)
    _jsx("div", {
      className: `ceui-pane ${CONTENT_PANE_CLASSNAME} flex-container`,
      children: /*#__PURE__*/_jsx("div", {
        className: `${EDIT_PANE_CLASSNAME}`,
        children: /*#__PURE__*/_jsxs("div", {
          className: "contentEditor-iframe",
          children: [/*#__PURE__*/_jsx(PreloadedIframeProxy, {
            proxyTop: true,
            proxyLeft: true,
            proxyRight: true,
            proxyDisplay: true,
            iframeWrapperElement: previewIframeElement,
            iframeStylesManager: PreviewIframeStylesManager
          }), /*#__PURE__*/_jsx(SkeletonPreviewIframeStyler, {
            iframeWrapperElement: previewIframeElement
          }), /*#__PURE__*/_jsx(AppWideKeyboardShortcutsContainer, {
            redoAction: () => dispatch(redoModuleReducerChange()),
            undoAction: () => dispatch(undoModuleReducerChange())
          })]
        })
      })
    })
  );
};

// Need to make PreviewViewportSizeHOC a _parent_ of ContentViewContainer, because it needs to know
// when the edit pane has been fully mounted (and that is easier by making it a parent instead of passing
// `hasMounted={true}` to a child component)
export default PreviewViewportSizeHOC(ContentViewContainer);